export default {"src":"/_next/static/media/SettingIcon.21ee008c.svg","height":20,"width":20};